<template>
  <div class="register-block">
    <div class="fourth-block-inner row animate-slidein">
      <div class="flex-box">
        <div class="flex-left">
          <div class="logo">
            <img :src="gameContent.logo" alt="vordur logo" height="110" width="110" />
          </div>
          <h2>{{ pageContent.title }}</h2>
          <p class="yellow-line"></p>
          <p class="rules" v-html="pageContent.description"></p>
        </div>
        <div class="flex-right">
          <div class="text-wrap" v-html="pageContent.moreDetails"></div>
          <div class="login-block">
            <div class="form-group user">
              <input  type="name" v-model="userInfo.name" id="name">
              <label for="name">Leikmaður:</label>
            </div>
            <div class="form-group">
              <input type="email" v-model="userInfo.email" id="email">
              <label for="email">Netfang:</label>
            </div>
          </div>
          <label class="checkbox-group">
            <input type="checkbox" v-model="userInfo.has_terms_accepted" id="terms">
            <span>Ég hef lesið og samþykki leikreglurnar</span>
          </label>
          <div class="email-button col-md-12 login desktop-view">
            <button type="button" class="button btn-svara" v-on:click="process()" :disabled="!userInfo.has_terms_accepted">{{ pageContent.cta_links[0].text }}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="email-button login mobile-view">
      <button type="button" class="button btn-svara" v-on:click="process()" :disabled="!userInfo.has_terms_accepted">{{ pageContent.cta_links[0].text }}</button>
    </div>
  </div>
</template>
<script>
import { UserInfo } from '@/shared/dataModels'
import API from '@/shared/api'
export default {
  name: 'LoginBoard',
  props: ['greetingInfo'],
  data () {
    return {
      facebook: null,
      userData: null,
      userInfo: new UserInfo(),
      mandatoryFields: ['name', 'email'],
      missedFields: [],
      nextUrl: null,
      gameContent: {},
      pageContent: {},
    }
  },
  created () {
    if (this.$route.query && this.$route.query.next_url) {
      this.nextUrl = this.$route.query.next_url
    }
    if (this.$data.globalData.gameContent) {
      this.gameContent = this.$data.globalData.gameContent
    }
    if (this.$data.globalData.pageContent) {
      this.pageContent = this.$data.globalData.pageContent['login']
    }
  },
  methods: {
    async validateNextUrl () {
      API.meInstance.post('/validate_next_url', {
        next_url: this.nextUrl,
      }).then((res) => {
        window.location.href = this.nextUrl.indexOf('frjals-spilun') > -1
          ? '/frjals-spilun/?showclub=true' : (res.data.next_url || '/');
      }).catch((error) => {
        console.log('Error validating next url', error);
      });
    },
    process () {
      this.missedFields = this.isValidData()
      if (this.missedFields.length === 0) {
        let regExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (regExp.test(this.userInfo.email)) {
          this.$emit('showLoader')
          API.meInstance.post(`/email/login/?req_time=${new Date().toISOString()}`, this.userInfo).then((res) => {
            if (res) {
              if (res.data.status) {
                const h = this.$createElement
                this.$notify({
                  // title: 'Árangur',
                  customClass: 'success-msg',
                  message: h('i', { style: 'color: #6cc65b' }, 'Skráning tókst')
                })
                setTimeout(() => {
                  if (this.nextUrl) {
                    this.validateNextUrl(this.nextUrl)
                  } else {
                    window.location.href = '/spurningar/?showclub=true'
                  }
                  this.showModalBox = false
                }, 1000);
              } else {
                const h = this.$createElement
                this.$notify({
                  // title: 'Villa',
                  customClass: 'error-msg',
                  message: h('i', { style: 'color: #f7653a' }, res.data.error)
                })
              }
            }
          }).catch((error) => {
            const h = this.$createElement
            this.$notify({
              // title: 'Villa',
              customClass: 'error-msg',
              message: h('i', { style: 'color: #f7653a' }, 'Villa, ekki hægt að klára beiðni.')
            })
          })
        } else {
          const h = this.$createElement
          this.$notify({
            // title: 'Villa',
            customClass: 'error-msg',
            message: h('i', { style: 'color: #f7653a' }, 'Vinsamlegast settu virkan tölvupóst')
          })
        }
      } else {
        const h = this.$createElement
        let req = []
        for (let i = 0; i < this.missedFields.length; i++) {
         var key = this.missedFields[i]
          if (!key) return ''
          key = key.toString()
          key = key.split('-').join(' ')
          key = key.split('_').join(' ')
          req.push(' ' + key.charAt(0).toUpperCase() + key.slice(1))
        }
        let filedName = req.join()
        this.$notify({
          // title: 'Villa',
          customClass: 'error-msg',
          message: h('i', { style: 'color: #f7653a' },
           'Það verður að fylla út í alla reiti.')
        })
      }
    },
    isValidData () {
      let missedFields = []
      for (let fieldIndex in this.mandatoryFields) {
        if (this.userInfo && this.userInfo[this.mandatoryFields[fieldIndex]] && this.userInfo[this.mandatoryFields[fieldIndex]] !== '') {
          continue
        } else {
          missedFields.push(this.mandatoryFields[fieldIndex])
        }
        
      }
      return missedFields
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-view {
  display: none;
  @media screen and (min-width: 768px) {
    display: inline;
  }
}
.register-block {
  position: relative;
  max-width: 800px;
  margin: 20px auto 30px;
  @media screen and (min-width: 767px) {
    padding-top: 0 !important;
  }
  @media screen and (min-width: 1200px) {
    margin: 0 auto;
  }
}
.row {
  // display: block;
}
h1 {
  margin-top: 0;
}
.form-group {
  input {
    padding: 1.5rem;
  }
}
.social-network-inner {
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 1.5rem;
  margin-bottom: 5rem;
  display: block;
  &.facebook {
    background: #415A93;
  }
  &.google {
    background: #E44444;
  }
  label {
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: #FFFFFF;
  }
}
.text-wrap {
  min-height: 68px;
  padding-bottom: 30px;
  /deep/h4,p {
    font-weight: 600;
    font-size: 18px;
    line-height: 140%;
    color: #011627;
  }
  p {
    font-weight: normal;
  }
}
.social-network-block {
  padding-top: 2.5rem;
  label {
    padding-bottom: 3px;
    padding-top: 3px;
  }
}
.checkmark {
  top: 5px;
}
.container input:hover ~ .checkmark {
  background: #FCBD00;
  border: 1px solid #FCBD00;
  opacity: 1;
}
.email-button {
  text-align: center;
  &.login {
    padding: 1rem 0;
  }
}
.container input:hover ~ .checkmark:after {
  display: block;
}
.animate-slidein {
  -webkit-animation-duration: 1.5s;
  animation-duration: 1.5s;
}
.btn-svara {
  // margin-right: 1.6rem;
  padding: 1.5rem 16rem;
  @media screen and (min-width: 768px) {
    width: 100%;
  }
  @media screen and (min-width: 1200px) {
    width: unset;
  }
}
@media (max-width: 767px) {
  .email-button {
    position: initial;
    background: transparent;
  }
  .login-block {
    padding-bottom: 1rem;
  }
}
.flex-box {
  display: flex;
  flex-direction: column;
  max-width: 500px;
  box-sizing: border-box;
  width: 100%;
  // margin-top: 15px;
  @media screen and (min-width: 768px){
    margin-top: 0;
  }
  @media screen and (min-width: 1200px){
    flex-direction: row;
    max-width: unset;
    margin-top: 0;
  }
  .flex-left {
    flex: 1;
    width: 100%;
    align-self: top;
    margin-top: 25px;
    @media screen and (min-width: 768px){
      margin-left: 10px;
      width: 100%;
    }
    @media screen and (min-width: 1200px){
      width: 50%;
      margin-right: 25px;
      margin-left: 0;
    }
    .logo {
      display: flex;
      @media screen and (min-width: 768px){
        display: block;
        max-width: unset;
      }
    }
    .yellow-line {
      border: 1px solid #FCBD00;
      width: 19px;
      height: 2px;
      margin-bottom: 1rem;
    }
    h2 {
      font-size: 30px;
      line-height: 40px;
      color: #011627;
      font-weight: 600;
      margin: .6rem 0;
      @media screen and (min-width: 768px){
        font-size: 40px;
        line-height: 50px;
        margin: 3rem 0;
      }
      @media screen and (min-width: 1200px){
        font-size: 50px;
        line-height: 65px;
      }
    }
    p, /deep/p {
      margin-bottom: 0;
      @media screen and (min-width: 1200px){
        max-width: 340px;
      }
    }
    p.rules {
      border-radius: 10px;
      margin-top: 10px;
    }
  }
  .flex-right {
    margin: 0;
    margin-top: 30px;
    @media screen and (min-width: 768px){
      margin-left: 0;
      margin-right: 0;
    }
    @media screen and (min-width: 1200px){
      margin-left: 25px;
      margin-right: 0;
    }
    .text-wrap{
      margin-left: 0px;
      padding-bottom: 15px;
      /deep/h4 {
        margin-top: 0;
      }
      @media screen and (min-width: 768px){
        margin-left: 6px;
      }
    }
    .button.btn-svara {
      width: 100%;
      // padding-right: 6px;
      @media screen and (min-width: 768px){
        width: 100%;
        // padding-right: unset;
      }
    }
  }
}
.checkbox-group {
  display: flex;
  align-items: center;
  gap: 10px;
  input {
    margin-top: 0;
    height: 20px;
    width: 20px;
  }
  span {
    font-size: 18px;
    font-weight: 600;
    color: #011627;
  }
}
@media screen and (max-width: 767px) {
  .flex-box {
    .flex-left {
      margin-top: 0;
      .logo {
        height: 50px;
        width: 50px;
      }
      .yellow-line {
        margin-bottom: 3rem;
      }
    }
  }
}
</style>
